'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _path = require('helpers/path');

var _Search = require('features/Search/Search.route');

// polyfill webpack require.ensure
if (typeof require.ensure !== 'function') require.ensure = function (deps, cbFn) {
  return cbFn(require);
};

exports.default = function () {
  var redirectToSearch = function redirectToSearch(nextState, replaceState, cb) {
    var url = '' + nextState.location.pathname + nextState.location.search;
    var nextPath = url.replace(/^\/explore/, _Search.PATH);

    return (0, _path.redirectTo)(nextPath)(nextState, replaceState, cb);
  };

  return {
    path: '/explore',

    onEnter: redirectToSearch,

    getIndexRoute: function getIndexRoute(location, callback) {
      require.ensure([], function () {
        callback(null, {
          onEnter: redirectToSearch
        });
      }, 'explore');
    },

    getChildRoutes: function getChildRoutes(location, callback) {
      require.ensure([], function () {
        callback(null, [{ path: '*', onEnter: redirectToSearch }]);
      }, 'explore');
    }
  };
};